import React from "react";
import { readMeasurementSession } from "./measurementSession";
import { useT } from "../../../i18n/useT";

const MeasurementSessionStrip = ({ moduleId }) => {
  const t = useT("testModule");
  const session = readMeasurementSession();
  const queue = session?.queue || [];
  if (queue.length < 2) return null;

  const currentIndex = Math.max(
    0,
    queue.findIndex((module) => Number(module.moduleId) === Number(moduleId)),
  );
  const showBackgroundUploadNote =
    currentIndex > 0 || (session.completedModuleIds || []).length > 0;

  return (
    <div className="measurement-session-strip">
      <div className="session-progress-row">
        <div className="session-dots" aria-hidden="true">
          {queue.map((module, index) => (
            <span
              key={module.moduleId}
              className={`session-dot ${
                index < currentIndex
                  ? "done"
                  : index === currentIndex
                    ? "cur"
                    : ""
              }`}
            />
          ))}
        </div>
        <div className="session-label">
          {t("session_progress", {
            current: currentIndex + 1,
            total: queue.length,
          })}
        </div>
      </div>
      {showBackgroundUploadNote ? (
        <div className="session-upload-note">{t("session_upload_note")}</div>
      ) : null}
    </div>
  );
};

export default MeasurementSessionStrip;
